import { PropsWithChildren } from 'react'

type TextProps = {}

export const Text = ({ children }: PropsWithChildren<TextProps>) => (
  <p className="text-sm font-semibold pr-1">{children}</p>
)
